import { createContext, useContext } from 'react';
import { Ability, AnyAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';

import { useAuthQuery } from '../../auth/hooks/useAuthQuery';
import { actions, subjects } from '../../constants/abilities';

const AbilityContext = createContext<AnyAbility>(new Ability());

const AbilityProvider = ({ children }) => {
  const { user } = useAuthQuery();

  const ability = new Ability(user?.rules || []);

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
};

const Can = createContextualCan(AbilityContext.Consumer);

const useAbility = () => {
  const abilityContext = useContext(AbilityContext);

  if (!abilityContext) {
    throw new Error('useAbility must be used within an AbilityProvider');
  }

  return abilityContext;
};

export { AbilityProvider, Can, useAbility, subjects, actions };
